import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

const Home = () => import("../views/home/home.vue"); // 组件  框架汇总
const Music = () => import("../views/music/music.vue"); // 音乐组件
const Me = () => import("../views/me/me.vue"); //  关于我 组件
const NavBar = () => import("../views/topBar/topbar.vue"); //  导航 组件
const FootBar = () => import("../views/footbar/footbar.vue"); //  foot 组件

const Firstpage = () => import("../views/firstpage/firstpage.vue"); //  首页


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HelloWorld',
      component: Firstpage
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/music',
      name: 'music',
      component: Music
    },
    {
      path: '/me',
      name: 'me',
      component: Me
    },
    {
      path: '/nav',
      name: 'nav',
      component: NavBar
    },
    {
      path: '/footbar',
      name: 'footbar',
      component: FootBar
    },
    {
      path: '/firstpage',
      name: 'firstpage',
      component: Firstpage
    },

  ],

  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }

})



// WEBPACK FOOTER //
// ./src/router/index.js